<!-- 嵌入式-确认维修 -->
<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <el-input
          v-model.trim="key"
          placeholder="名称、SN或送修来源"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-select v-model="former.Type" clearable placeholder="维修类型">
          <el-option label="产品" :value="0"></el-option>
          <el-option label="配件" :value="1"></el-option> </el-select
        >&nbsp;
        <select2
          labelName="Name"
          v-model="former.DealPeopleID"
          url="user"
          clearable
          placeholder="处理人"
          no-data-text="没有处理人"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.DealStatus"
          url="dci/maintain/status-list"
          clearable
          placeholder="维修状态"
          no-data-text="没有维修状态"
          :currentList="curStatus"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(40, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column label="类型" width="65">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Type === 0" type="warning"> 产品 </el-tag>
          <el-tag v-if="scope.row.Type === 1" type="success"> 配件 </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件型号名称" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.DciProductModel.NameNumber }}
          </div>
          <div v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.DciAccessoryModel.NameNumber }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件SN" width="190">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.SN }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.DciProduct !== null && scope.row.DciProduct.Remark !== ''">
            {{ scope.row.DciProduct.Remark }}
          </el-tag> 
          <el-tag v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="送修来源">
        <template slot-scope="scope">
          {{ scope.row.SendSource }}
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.AmbSaleOrderCode !== ''"
          >
            <div slot="content">报价单：{{scope.row.AmbSaleOrderCode}}</div>
            <i
              class="fas fa-file"
              style="color: #67c23a; cursor: pointer"
              @click="onShowSaleOrder(scope.row)"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="送修日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.SendAt">
            {{ $sys.dateFormat(scope.row.SendAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template slot="header" slot-scope="scope">
          <div style="padding-left: 0px;padding-right: 0px;line-height: normal;">期望初检完成日期</div>
          <div style="padding-left: 0px;padding-right: 0px;line-height: normal;margin-top: -5px;">期望维修完成日期</div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.ExpectedInspectAt &&
              new Date(scope.row.ExpectedInspectAt).getTime() <=
                new Date(new Date()).getTime() &&
              (scope.row.DealStatus === 0 ||
                scope.row.DealStatus === 1 ||
                scope.row.DealStatus === 2)
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedInspectAt">
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div
            v-if="
              scope.row.ExpectedDealAt &&
              new Date(scope.row.ExpectedDealAt).getTime() <=
                new Date(new Date()).getTime() &&
              scope.row.DealStatus !== 6
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedDealAt">
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="更换方式" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.ReplacementMode === 0" type="warning">
            不更换
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 1" type="primary">
            更换配件
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 2" type="info">
            更换整机
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="DealPeople.Name" label="处理人" width="70" />
      <el-table-column prop="DealStatusName" label="维修状态" width="105">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DealStatus === 3" type="warning">
            {{ scope.row.DealStatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ scope.row.DealStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="220" label="操作">
        <template slot-scope="scope">
          <el-button
            type="button"
            @click.stop="onDetailItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onChangeItem(scope.row)"
            title="更换申请"
            :disabled="scope.row.ReplacementMode === 0"
            v-if="scope.row.DealStatus === 3"
          >
            <i class="fas fa-edit"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onConfirmClick(scope.row)"
            title="确认维修"
            v-if="scope.row.DealStatus === 3"
          >
            <i class="fas fa-wrench"></i>
          </el-button>
          <el-button
            type="success"
            @click.stop="onFinishClick(scope.row)"
            title="直接办结"
            v-if="scope.row.DealStatus === 3"
          >
            <i class="fas fa-tasks"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onBackClick(scope.row)"
            title="退回"
            v-if="scope.row.DealStatus === 3"
          >
            <i class="fas fa-share-square"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <detail-form v-model="item" :visible.sync="deltailVisible" />

    <change-form
      v-model="changeItem"
      :visible.sync="changeVisible"
      @form:saved="getItemList"
    />

    <el-dialog
      title="确认维修"
      :visible.sync="confirmVisible"
      :close-on-click-modal="false"
      @close="onCloseConfirm"
      width="30%"
    >
      <el-form
        ref="confirmItemForm"
        label-width="150px"
        :model="confirmItem"
        :rules="confirmRules"
      >
        <el-form-item label="期望维修完成日期" prop="ExpectedDealAt">
          <el-date-picker
            v-model="confirmItem.ExpectedDealAt"
            style="width: 100%"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseConfirm">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onConfirmItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <finish-form
      v-model="finishItem"
      :visible.sync="finishVisible"
      @form:saved="getItemList"
    />
    
    <el-dialog
      title="退回维修初检"
      :visible.sync="backVisible"
      :close-on-click-modal="false"
      append-to-body
      @close="onCloseBack"
      width="40%"
    >
      <el-form
        ref="backItemForm"
        label-width="100px"
        :model="backItem"
        :rules="backRules"
      >
        <el-form-item label="退回原因" prop="BackDesc">
          <el-input
            v-model.trim="backItem.BackDesc"
            :autosize="{ minRows: 5 }"
            type="textarea"
            placeholder="请输入退回原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseBack">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onBackItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import ChangeForm from "./changeForm.vue"; //确认维修
import DetailForm from "../maintainRegister/detail.vue"; //使用维修登记中的维修详情，公用
import FinishForm from "./finishForm.vue"; //直接办结

export default {
  components: {
    ChangeForm,
    DetailForm,
    FinishForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        Type: "",
        DealPeopleID: "",
        DealStatus: "",
      },
      confirmItem: {
        ID: "",
        ExpectedDealAt: "",
      },
      confirmRules: {
        ExpectedDealAt: [
          {
            required: true,
            message: "期望维修完成日期不能为空",
            trigger: "blur",
          },
        ],
      },
      key: "",
      item: this.getEmptyItem(),
      changeItem: this.getEmptyChangeItem(),
      finishItem: this.getEmptyFinishItem(),
      changeVisible: false, //更换申请
      deltailVisible: false, //查看详情
      confirmVisible: false, //确认维修
      finishVisible: false, //直接办结
      backVisible: false, //退回维修初检
      curStatus: [],
      
      backItem: {
        ID: "",
        BackDesc: "",
      },
      backRules: {
        BackDesc: [
          { required: true, message: "退回原因不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getItemList();
  },
  created() {
    this.curStatus = [
      {
        Key: 3,
        Value: "确认维修中",
      },
    ];
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/maintain/confirm", {
          params: {
            where: this.former,
            with: [
              "DciProduct.DciProductModel",
              "DciAccessory.DciAccessoryModel",
              "MaintainUser",
              "SendPeople",
              "DealPeople",
              // "DciSaleOrder",
            ],
            ...this.pager,
            key: this.key,
            order: ["deal_status", "-send_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //更换申请
    onChangeItem(row) {
      if (row.ReplacementMode === 0) {
        this.$message.warning("该维修记录的更改方式是不更换，请重新确认");
        return;
      }

      this.changeItem = this.getEmptyChangeItem();
      this.$axios
        .get("dci/maintain/change", {
          params: {
            DciProductMaintainID: row.ID,
          },
        })
        .then((response) => {
          this.changeItem = response.data;
          this.changeItem.Type = row.Type;
          this.changeVisible = true;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //维修详情
    onDetailItem(row) {
      this.item = row;
      this.deltailVisible = true;
    },
    getEmptyItem() {
      return {};
    },
    getEmptyChangeItem() {
      return {
        ID: "", //新增为0 ，修改是更换信息id
        Type: 0, //维修类型 0:产品 1:配件
        DciProductMaintainID: "", //维修记录id
        DciProductID: "", //产品ID
        DciAccessoryID: "", //配件ID
        EntName: "", // 企业名称
        StationName: "", // 站点名称
        IsWarrantyPeriod: false, // 是否质保期 0:否.1:是
        IsMaintenancePeriod: false, // 是否我司运维期 0:否.1:是
        MalfunctionDesc: "", //故障说明
        MaintainScheme: "", //维修方案
      };
    },
    getEmptyFinishItem() {
      return {
        ID: "", //维修id
        FinishDesc: "", //直接办结原因
        ExpressNumber: "", //快递单号
        SendingAt: new Date(), //寄出日期
        Addressee: "", //收件人
        ExpressDesc: "", //快递说明
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    onConfirmClick(row) {
      this.confirmVisible = true;
      this.confirmItem.ID = row.ID;
      this.confirmItem.ExpectedDealAt = row.ExpectedDealAt;
    },
    onCloseConfirm() {
      this.confirmVisible = false;
      this.$refs.confirmItemForm.resetFields();
    },
    //确认维修
    onConfirmItem() {
      this.$refs.confirmItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/maintain/confirm",
            method: "post",
            data: this.confirmItem,
          })
          .then(() => {
            this.getItemList();
            this.$message.success("提交成功");
            this.confirmVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },

    //直接办结
    onFinishClick(row) {
      this.finishItem = this.getEmptyFinishItem();
      this.finishItem.ID = row.ID;
      this.finishVisible = true;
    },

    //退回维修初检
    onBackClick(row) {
      this.backVisible = true;
      this.backItem.ID = row.ID;
    },
    onCloseBack() {
      this.backVisible = false;
      this.$refs.backItemForm.resetFields();
    },
    //退回维修登记
    onBackItem() {
      this.$refs.backItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/maintain/confirm-back",
            method: "post",
            data: this.backItem,
          })
          .then(() => {
            this.getItemList();
            this.$message.success("退回成功");
            this.backVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
    onShowSaleOrder(row){
        window.open(row.AmbSaleOrderUrl, "_blank");
    },
    // //打印维修报价单【暂不启用】
    // onPrintSaleOrder(row) {
    //   this.$axios
    //     .get(`dci/maintain/sale/print/${row.DciSaleOrderID}`, {
    //       responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
    //     })
    //     .then((res) => {
    //       if (!res) {
    //         return;
    //       }
    //       const blob = new Blob([res.data], {
    //         type: "application/vnd.ms-excel",
    //       }); // 构造一个blob对象来处理数据，并设置文件类型

    //       let fName = "维修报价单";
    //       if (row.DciSaleOrder.Code !== "") {
    //         fName += "(" + row.DciSaleOrder.Code + ")";
    //       }
    //       fName += ".xlsx";

    //       if (window.navigator.msSaveOrOpenBlob) {
    //         //兼容IE10
    //         navigator.msSaveBlob(blob, fName);
    //       } else {
    //         const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
    //         const a = document.createElement("a"); //创建a标签
    //         a.style.display = "none";
    //         a.href = href; // 指定下载链接
    //         a.download = fName; //指定下载文件名
    //         a.click(); //触发下载
    //         URL.revokeObjectURL(a.href); //释放URL对象
    //       }
    //       // 这里也可以不创建a链接，直接window.open(href)也能下载
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
};
</script>

